import { connect } from 'react-redux'
import ProviderProductSearch from '../../components/products/ProviderProductSearch'
import { IStoreState } from '../../types'
import * as actions from '../../state/actions/provider-products'

export function mapStateToProps(state: IStoreState): any {
  return {
    query: state.providerProduct.query
  }
}

export function mapDispatchToProps(dispatch: any): any {
  return {
    onChange: (e: any) => dispatch(actions.actionCreators.filterProducts(e.target.value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductSearch)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductSearch.ts